import React, { useState } from 'react'
import { Collapse, Icon, Tooltip } from 'antd'
import { FormSubmitButton, FormatText, MasterDetailForm, Widget, usePromise, Row, FormNumber } from '@digital/ui'
import { GetSubcontratacao, UpdateSubcontratacao } from '@app/api/configuracoes'
import { hasPermission } from '@app/helpers/permissions'

const { Panel } = Collapse

const ConfiguracaoSubcontratacao = () => {
    const [update, setUpdate] = useState(false)
    const [dados] = usePromise(async () => await GetSubcontratacao(), [update], {})

    const onUpdate = (values: any) => {
        UpdateSubcontratacao(values).then(data => {
            if (data.valid) {
                setUpdate(!update)
            }
        })
    }

    return (
        <>
            <Collapse bordered={false} expandIcon={() => <Icon type="arrows-right_4" />}>
                <Panel key="configuracoesSubcontratacao" header="Parâmetros Subcontratação">
                    <MasterDetailForm
                        initialValues={dados}
                        onSubmit={onUpdate}
                    >
                        <Widget
                            actions={[
                                hasPermission(['CONFIGURACAO_SUBCONTRATACAO_EDITAR']) && (
                                    <FormSubmitButton noIcon type="primary">
                                        <FormatText id="ui.commons.save" uppercase />
                                    </FormSubmitButton>
                                )
                            ]}
                        >
                            <Row>
                                <FormNumber
                                    label="Prazo de Notificação Subcontratações (dias)"
                                    name="subcontratacaoPrazoNotificacao"
                                    span={2}
                                    min={1}
                                    maxLength={4}
                                />
                            </Row>
                        </Widget>
                    </MasterDetailForm>
                </Panel>
            </Collapse>
        </>
    )
}

export default ConfiguracaoSubcontratacao